import React from "react";
import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { UserCtx } from "../../context/userContext";
import { SubscriptionCtx } from "../../context/subscriptionContext";
import { isLifetimeSubscription } from "../../constants/lifetimePromoCodes";
import useDate from "../../hooks/useDate";

const PrivateRouteCoach = () => {
    const { user } = React.useContext(UserCtx);
    const { activeSubscription } = React.useContext(SubscriptionCtx);
    const { iso, now } = useDate()
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const keys = Array.from(searchParams.keys());
    const params: any = {};
    keys.forEach((key) => {
        params[key] = searchParams.get(key);
    });
    const trialActive = iso(user.trialExpiration) > now;
    
    const lifetime = isLifetimeSubscription(activeSubscription?.subscription_promo_code);
    
    let route = <Outlet />;
    if (user) {
        if (user?.isCoach) {
            if (user?.isSubscribed || trialActive || lifetime) {
                route = <Outlet />;
            } else {
                route = (
                    <Navigate
                        to="/coach/subscription/current"
                    />
                ) 
            }
        } else {
            route = (
                <Navigate
                    to="/member"
                />
            )
        }
    } else {
        route = (
            <Navigate
                to="/sign-in"
                state={{
                    storageAvailable: true,
                    pathname: location.pathname,
                    searchParams: params,
                }}
            />
        );
    }
    return route;
};

export default PrivateRouteCoach;
